<template>
  <div class="container-fluid mt-3">
    <b-card header="Notifications">
      <notifications-widget :all="true"></notifications-widget>
    </b-card>
  </div>
</template>

<script>
import NotificationsWidget from '../components/Dashboard/NotificationsWidget';
export default {
  name: 'Notifications',
  components: {NotificationsWidget},
  data () {
    return {};
  },
  methods: {},
  mounted () {},
  metaInfo: {
    title: 'Notifications'
  }
};
</script>
